import React from 'react';
import { motion } from 'framer-motion';

const SectionHeading = ({ title, subtitle, align = 'left', className = '' }) => {
  return (
    <div className={`mb-16 ${align === 'center' ? 'text-center' : 'text-left'} ${className}`}>
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
      >
        {subtitle && (
          <span className="block text-xs uppercase tracking-[0.2em] text-brand-red dark:text-brand-yellow mb-3 font-bold">
            {subtitle}
          </span>
        )}
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-slate-900 dark:text-white leading-tight">
          {title}
        </h2>
        {align === 'center' && (
          <div className="w-16 h-1.5 bg-brand-cyan mx-auto mt-6"></div>
        )}
        {align === 'left' && (
          <div className="w-16 h-1.5 bg-brand-cyan mt-6"></div>
        )}
      </motion.div>
    </div>
  );
};

export default SectionHeading;